<template>
  <div>
    <b-navbar toggleable="lg" type="dark">
      <b-navbar-brand href="#"></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav align="center">
        <b-navbar-nav>
          <b-nav-item href="#" v-scroll-to="'#firstPage'">HOME</b-nav-item>
          <b-nav-item href="#" v-scroll-to="'#secondPage'">活動介紹</b-nav-item>
          <b-nav-item href="#" v-scroll-to="'#thirdPage'">議程表</b-nav-item>
          <b-nav-item href="#" v-scroll-to="'#fourthPage'"
            >報名發表會</b-nav-item
          >
          <b-nav-item href="https://youtu.be/9QNBOjgY8OQ" target="b_blank"
            >線上直播</b-nav-item
          >
          <b-nav-item href="#" v-scroll-to="'#sixthPage'">交通指南</b-nav-item>
          <b-nav-item
            href="https://ezsign.gis.tw/moi1004event/#/"
            target="_blank"
            >國家底圖空間資訊應用成果發表週</b-nav-item
          >
          <b-nav-item
            href="https://drive.google.com/drive/folders/1GHkcKUUXoPaqbHK0H1JpihTFqn903UCM?usp=sharing"
            target="_blank"
            >研討會簡報下載</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div id="wrapper">
      <div id="firstPage" class="section home">
        <h1 class="main-title-group">
          <div class="main-title" data-aos="fade-up">
            三維空間資訊基礎環境共構及資料聯盟應用<br />成果發表會
          </div>
          <div class="main-title-date" data-aos="fade-up" data-aos-delay="200">
            2021年10月6日(三) 13:00-17:10
          </div>
          <div class="main-title-time" data-aos="fade-up" data-aos-delay="300">
            集思台大會議中心 米開朗基羅廳<br />(台北市大安區羅斯福路四段85號B1)
          </div>
          <!-- <a class="btn" href="#" v-scroll-to="'#fourthPage'"
            ><span class="icon icon-arrow-right mr-1"></span>報名發表會</a
          > -->
          <a class="btn"  href="https://youtu.be/9QNBOjgY8OQ" target="b_blank"
            ><span class="icon icon-arrow-right mr-1"></span>線上直播</a
          >
        </h1>
      </div>

      <div id="secondPage" class="section forum-info">
        <div class="container">
          <h2>活動介紹</h2>
          <div class="row">
            <div class="col-lg-6">
              <p>
                財團法人國家實驗研究院國家高速網路與計算中心於110年起基於全國性公共服務網路傳輸效率與韌性強化，導入先進網路傳輸技術與智慧網路管理，並以雲端應用框架為基礎，規劃國家三維空間資訊基礎環境共構，強韌公部門多維度空間圖資整合與分析展示應用、降低軟硬體建置成本與提升圖資流通效益，期能促成我國三維空間資訊技術產業的發展。
              </p>
              <p>
                國網中心秉著「空間資訊基礎環境共構共享」理念，參與110/10/04(一)~10/08(五)【國家底圖空間資訊應用成果發表週】活動。並於10/6(三)辦理【三維空間資訊基礎環境共構及資料聯盟應用成果發表會】，會中將展示三維空間資訊整合應用案例與資料聯盟成果，並誠摯邀請各界專家學者與會交流討論。
              </p>
              <p class="text-danger" style="font-size: 16px">
                ※
                全國COVID-19（2019冠狀病毒疾病）二級警戒，本成果週活動配合室內防疫人數限制控管集會人數。
              </p>
              <p class="text-danger" style="font-size: 16px">
                ※
                配合政府防疫宣導及確保與會人員安全，進場前須配合體溫量測、手部酒精消毒及會議廳內應全程配戴口罩。
              </p>
              <p class="text-danger" style="font-size: 16px">
                ※
                提醒您若體溫量測，額溫高於37.5度或耳溫高於38度、或有發燒、咳嗽等症狀，請勿進入，以維護自身及他人健康安全！
              </p>
            </div>
            <div class="col-lg-6">
              <img
                src="imgs/info_img.png"
                class="img-fluid"
                alt=""
                data-aos="fade-left"
                data-aos-delay="200"
              />
              <a href="http://rasai.colife.org.tw/LandingPage/" target="_blank">
                  <img
                  src="imgs/info_link_img.jpg"
                  class="img-fluid pt-3"
                  alt=""
                  data-aos="fade-left"
                  data-aos-delay="200"
                />
                </a>
            </div>
          </div>
        </div>
      </div>

      <div id="thirdPage" class="section forum-schedule">
        <div class="container">
          <h2 style="display: inline-block">議程表</h2>
          <h3 style="display: inline-block; color: white" class="ml-5">
            ※線上直播觀看無人數限制
          </h3>
          <a
            class="btn float-right"
            href="https://ezsign.gis.tw/nchc1006event/國家高速網路與計算中心_議程.pdf"
            target="_blank"
            ><span class="icon icon-download2 mr-1"></span>議程表下載</a
          >
          <div class="clearfix"></div>

          <div class="agenda-timeline">
            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">13:00</div>
              <div class="agenda-timeline-content">報到</div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">13:20</div>
              <div class="agenda-timeline-content">開場/合照/貴賓致詞</div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">13:30</div>
              <div class="agenda-timeline-content">
                主題一：三維共構應用成果
                <small class="d-block">主持人：財團法人國家實驗研究院國家高速網路與計算中心 林錫慶副主任</small>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  海空三維資訊平台應用於災害救援情資整合
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span
                  >逢甲大學地理資訊系統研究中心 郝振宇副處長
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  臺中市易淹水地區抽水站預警系統
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span>臺中市政府水利局
                  廖健堯專門委員
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  感知城市聲音的脈動-三維噪音地圖之建構
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span
                  >中央研究院人文社會科學研究中心 詹大千研究員
                </div>
              </div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">15:00</div>
              <div class="agenda-timeline-content">交誼時間(Tea Break)</div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">15:20</div>
              <div class="agenda-timeline-content">
                主題二：資料聯盟應用成果
                <small class="d-block">主持人：財團法人國家實驗研究院國家高速網路與計算中心 林錫慶副主任</small>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  Datacubes: Enabling Building Blocks for AI, Digital Twins, and
                  Better Insight
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span>Jacobs University
                  Bremen Dr. Peter Baumann
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  高雄市政府農業局智慧農業三維展示應用案例
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span
                  >高雄市政府農業局農務管理科 陳似任股長
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  應用遙測植生指標分析居家環境綠蔽度與台灣兒童過敏性鼻炎的關聯
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span
                  >國立成功大學測量及空間資訊學系 吳治達副教授
                </div>
              </div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">16:50</div>
              <div class="agenda-timeline-content">QA交流
                <small class="d-block">主持人：財團法人國家實驗研究院國家高速網路與計算中心 林錫慶副主任</small>
              </div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">17:10</div>
              <div class="agenda-timeline-content">賦歸</div>
            </div>
          </div>
        </div>
      </div>

      <b-overlay
        id="overlay-background"
        :show="overlay"
        :opacity="0.5"
        rounded="sm"
        :spinner-type="overlay_type"
      >
        <div id="fourthPage" class="section forum-signup">
          <div class="container">
            <h2>報名發表會</h2>
            <b-form class="signup">
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>姓名</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-input
                    placeholder="請輸入姓名"
                    v-model="SignData.name"
                    :state="CheckState(SignData.name, true)"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>單位</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio name="govORsch" v-model="govORsch" value="0"
                    >政府部門</b-form-radio
                  >
                  <b-form-radio name="govORsch" v-model="govORsch" value="1"
                    >學術單位</b-form-radio
                  >
                  <b-form-radio name="govORsch" v-model="govORsch" value="2"
                    >公司行號</b-form-radio
                  >
                </b-col>
                <b-col sm="10" md="auto">
                  <b-row class="mb-1">
                    <b-form-input
                      v-model="SignData.position"
                      placeholder="請輸入單位名稱"
                      :state="CheckState(SignData.position, true)"
                    ></b-form-input>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>性別</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio name="gender" v-model="SignData.sex" value="0"
                    >男</b-form-radio
                  >
                  <b-form-radio name="gender" v-model="SignData.sex" value="1"
                    >女</b-form-radio
                  >
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>手機號碼</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-input
                    placeholder="請輸入手機號碼"
                    v-model="SignData.phone"
                    :state="CheckState(SignData.phone, CheckPhone)"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="CheckPhone"
                    >請填寫正確的手機號碼格式
                    Ex:0912345678</b-form-invalid-feedback
                  >
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>申請公務人員<br />終身學習時數</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio name="learn" v-model="learn" value="0"
                    >否</b-form-radio
                  >
                  <b-form-radio name="learn" v-model="learn" value="1"
                    >是</b-form-radio
                  >
                  <div v-if="learn == '1'">
                    <b-form-input
                      placeholder="請輸入身分證號碼"
                      v-model="SignData.idNum"
                      :state="CheckState(SignData.idNum, CheckidNum)"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="CheckidNum"
                      >請填寫正確的身分證格式</b-form-invalid-feedback
                    >
                  </div>
                  <a>如要申請公務人員終身學習時數，身分證請務必填寫。</a>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>電子信箱</label>
                </b-col>
                <b-col sm="10" md="auto" id="cmail">
                  <b-form-input
                    type="email"
                    placeholder="請輸入電子信箱"
                    v-model="SignData.email"
                    :state="CheckState(SignData.email, CheckMail)"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="CheckMail"
                    >請填寫正確的Email格式</b-form-invalid-feedback
                  >
                </b-col>
              </b-row>
              <hr />
              <h5 style="display: block">參加的場次</h5>
              <p style="font-size: 16px">
                本成果週活動配合室內防疫人數限制控管集會人數，如實體活動無法點選表示該場次報名人數已達上限，建議選擇線上直播參與。
              </p>
              <hr />
              <b-row class="mb-3">
                <!-- <b-col sm="2">
                  <label>參加的場次</label>
                  <div style="color: #4f4f4f; font-size: 10px">
                    *本成果週活動配合室內防疫人數限制控管集會人數，如實體活動無法點選表示該場次報名人數已達上限，建議選擇線上直播參與。
                  </div>
                </b-col> -->
                <b-col sm="10" md="auto">
                  <!-- <b-form-checkbox v-model="session1" @input="checkLunch"
                    >10/4(一) NGIS整合建置應用成果/柏拉圖廳</b-form-checkbox
                  >

                  <b-form-radio
                    :disabled="session1Disable == true"
                    name="Join1"
                    v-model="join1"
                    value="0"
                    v-if="session1 == true"
                    @input="checkLunch"
                    >實體發表
                    <div style="display: inline-block; color: red">
                      (參與人數上限：75人)
                    </div></b-form-radio
                  >
                  <b-form-radio
                    name="Join1"
                    v-model="join1"
                    value="1"
                    v-if="session1 == true"
                    @input="checkLunch"
                    >線上直播</b-form-radio
                  >

                  <b-form-checkbox v-model="session2" @input="checkLunch"
                    >10/5(二) 3D國家底圖建置現況及應用/柏拉圖廳</b-form-checkbox
                  >

                  <b-form-radio
                    :disabled="session2Disable == true"
                    name="Join2"
                    v-model="join2"
                    value="0"
                    v-if="session2 == true"
                    @input="checkLunch"
                    >實體發表
                    <div style="display: inline-block; color: red">
                      (參與人數上限：75人)
                    </div></b-form-radio
                  >
                  <b-form-radio
                    name="Join2"
                    v-model="join2"
                    value="1"
                    v-if="session2 == true"
                    @input="checkLunch"
                    >線上直播</b-form-radio
                  >

                  <b-form-checkbox v-model="session3" @input="checkLunch"
                    >10/6(三)
                    DTM加值應用成果/2021GIS競賽3D新創應用組初選活動暨人氣獎頒獎/米開朗基羅廳</b-form-checkbox
                  >

                  <b-form-radio
                    :disabled="session3Disable == true"
                    name="Join3"
                    v-model="join3"
                    value="0"
                    v-if="session3 == true"
                    @input="checkLunch"
                    >實體發表
                    <div style="display: inline-block; color: red">
                      (參與人數上限：43人)
                    </div></b-form-radio
                  >
                  <b-form-radio
                    name="Join3"
                    v-model="join3"
                    value="1"
                    v-if="session3 == true"
                    @input="checkLunch"
                    >線上直播</b-form-radio
                  > -->

                  <b-form-checkbox
                    v-model="session4"
                    @input="checkLunch"
                    style="color: blue"
                    >10/6(三)
                    三維空間資訊基礎環境共構及資料聯盟應用成果/米開朗基羅廳</b-form-checkbox
                  >

                  <b-form-radio
                    :disabled="session4Disable == true"
                    name="Join4"
                    v-model="join4"
                    value="0"
                    v-if="session4 == true"
                    @input="checkLunch"
                    >實體發表
                    <div style="display: inline-block; color: red">
                      (參與人數上限：31人)
                    </div></b-form-radio
                  >
                  <b-form-radio
                    name="Join4"
                    v-model="join4"
                    value="1"
                    v-if="session4 == true"
                    @input="checkLunch"
                    >線上直播</b-form-radio
                  >

                  <!-- <b-form-checkbox v-model="session5" @input="checkLunch"
                    >10/7(四)
                    2021自駕車高精地圖布建與導航安全實證國際研討會International
                    Conference on HD Maps and Localization for Autonomous
                    Driving Applications /洛克廳</b-form-checkbox
                  >

                  <b-form-radio
                    :disabled="session5Disable == true"
                    name="Join5"
                    v-model="join5"
                    value="0"
                    v-if="session5 == true"
                    @input="checkLunch"
                    >實體發表
                    <div style="display: inline-block; color: red">
                      (參與人數上限：15人)
                    </div></b-form-radio
                  >
                  <b-form-radio
                    name="Join5"
                    v-model="join5"
                    value="1"
                    v-if="session5 == true"
                    @input="checkLunch"
                    >線上直播</b-form-radio
                  >

                  <b-form-checkbox v-model="session6" @input="checkLunch"
                    >10/8(五) 地球觀測與地理資訊-國際鏈結Earth Observation for
                    Geo-Information System -International
                    Partnership/達文西廳</b-form-checkbox
                  > -->

                  <!-- <b-form-radio
                    :disabled="session6Disable == true"
                    name="Join6"
                    v-model="join6"
                    value="0"
                    v-if="session6 == true"
                    @input="checkLunch"
                    >實體發表
                    <div style="display: inline-block; color: red">
                      (參與人數上限：24人)
                    </div></b-form-radio
                  > -->
                  <b-form-radio
                    name="Join6"
                    v-model="join6"
                    value="1"
                    v-if="session6 == true"
                    @input="checkLunch"
                    >線上直播</b-form-radio
                  >
                </b-col>
              </b-row>

              <b-row class="mb-3" v-if="lunchVisible == true">
                <b-col sm="2">
                  <label>飲食需求</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio name="Lunch" v-model="SignData.Lunch" value="0"
                    >葷食</b-form-radio
                  >
                  <b-form-radio name="Lunch" v-model="SignData.Lunch" value="1"
                    >素食</b-form-radio
                  >
                  <b-form-radio name="Lunch" v-model="SignData.Lunch" value="2"
                    >不用餐</b-form-radio
                  >
                </b-col>
              </b-row>

              <hr />
              <h5 style="display: block">COVID-19防疫調查表</h5>
              <p style="font-size: 16px">
                為防範COVID-19疫情，主辦方為維護整場活動之健康與安全，我們需嚴格審視活動進行及評估所有風險。請與會貴賓配合下列問卷之調查，詳如以下說明：
              </p>

              <hr />
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>最近一個月是否出現以下症狀?</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio
                    name="COVID1"
                    v-model="SignData.Covid1"
                    value="0"
                    >否</b-form-radio
                  >
                  <b-form-radio
                    name="COVID1"
                    v-model="SignData.Covid1"
                    value="1"
                    >發燒(≧38℃)</b-form-radio
                  >
                  <b-form-radio
                    name="COVID1"
                    v-model="SignData.Covid1"
                    value="2"
                    >咳嗽/喉嚨痛/流鼻水</b-form-radio
                  >
                  <b-form-radio
                    name="COVID1"
                    v-model="SignData.Covid1"
                    value="3"
                    >呼吸道窘迫症狀(呼吸急促、呼吸困難)</b-form-radio
                  >
                  <b-form-radio
                    name="COVID1"
                    v-model="SignData.Covid1"
                    value="4"
                    >肌肉酸痛/關節酸痛</b-form-radio
                  >
                  <b-form-radio
                    name="COVID1"
                    v-model="SignData.Covid1"
                    value="5"
                    >其他</b-form-radio
                  >
                  <b-form-input
                    v-if="SignData.Covid1 == 5"
                    v-model="SignData.Covid1_Another"
                    placeholder="請輸入詳細說明"
                    :state="CheckState(SignData.Covid1_Another, true)"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>最近一個月是否有出國旅遊/接觸史(含轉機)? </label>
                  <div style="color: #4f4f4f; font-size: 10px">
                    * 若回答 「是」, 請填寫旅遊/接觸史(含轉機)地點
                  </div>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio
                    name="COVID2"
                    v-model="SignData.Covid2"
                    value="0"
                    >否</b-form-radio
                  >
                  <b-form-radio
                    name="COVID2"
                    v-model="SignData.Covid2"
                    value="1"
                    >是</b-form-radio
                  >
                  <b-form-input
                    v-if="SignData.Covid2 == 1"
                    v-model="SignData.Covid2_Another"
                    placeholder="請輸入詳細說明"
                    :state="CheckState(SignData.Covid2_Another, true)"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label
                    >您或您同住家屬、親友是否曾與感染嚴重特殊傳染性肺炎COVID-19之病患接觸?
                  </label>
                  <div style="color: #4f4f4f; font-size: 10px">
                    * 若回答 「是」, 請填寫您與病患接觸日期
                  </div>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio
                    name="COVID3"
                    v-model="SignData.Covid3"
                    value="0"
                    >否</b-form-radio
                  >
                  <b-form-radio
                    name="COVID3"
                    v-model="SignData.Covid3"
                    value="1"
                    >是</b-form-radio
                  >
                  <b-form-input
                    v-if="SignData.Covid3 == 1"
                    v-model="SignData.Covid3_Another"
                    placeholder="請輸入詳細說明"
                    :state="CheckState(SignData.Covid3_Another, true)"
                  ></b-form-input>
                </b-col>
              </b-row>

              <hr />

              <b-row class="mb-3">
                <b-col sm="10" offset-md="2" md="auto">
                  <b-form-checkbox v-model="terms1"
                    >我已經確認上述資料皆與證件相符</b-form-checkbox
                  >
                  <b-form-checkbox v-model="terms2"
                    >我已同意<b-link href="#" v-b-modal.modal-1
                      >『個資同意聲明』</b-link
                    ></b-form-checkbox
                  >
                  <b-form-checkbox v-model="terms3"
                    >我已詳閱並如實填寫上述「COVID-19
                    防疫調查表」</b-form-checkbox
                  >
                  <b-modal
                    id="modal-1"
                    title="個資同意聲明"
                    size="lg"
                    ok-only
                    ok-title="關閉"
                  >
                    <dl>
                      <dt>蒐集機關</dt>
                      <dd>逢甲大學地理資訊系統研究中心、易圖科技。</dd>
                      <dt>蒐集目的</dt>
                      <dd>「國家底圖空間資訊應用成果發表週」報名之用</dd>
                      <dt>資料類別</dt>
                      <dd>
                        個人身分證字號、姓名、生日、性別、服務單位、職稱、電子郵件、電話、手機、地址。
                      </dd>
                      <dt>使用方式</dt>
                      <dd>
                        由系統登錄後，於資料庫存放，由專案活動負責人員進行報名確認事宜。
                      </dd>
                      <dt>使用期限</dt>
                      <dd>
                        專案活動結束後或登錄公務人員學習時數後屆滿報名完成後，您得以下列聯絡方式行使查閱、更正等個人資料保護法第3條的當事人權利。
                      </dd>
                    </dl>
                    <p>
                      如您提供的資料不完整或不確實，將無法完成本次報名作業。
                    </p>
                  </b-modal>
                  <b-modal
                    id="modal-terms"
                    v-model="modal_terms_show"
                    title="報名失敗"
                    size="lg"
                    ok-only
                    ok-title="關閉"
                  >
                    <p>
                      請勾選個資同意聲明、確認證件、COVID-19
                      防疫調查表，否則將無法完成本次報名作業。
                    </p>
                  </b-modal>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="10" offset-md="2" md="auto">
                  <b-button
                    type="button"
                    variant="primary"
                    size="lg"
                    @click="CheckTerms"
                    >送出</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
            <b-modal
              id="modal-2"
              v-model="modal_2_show"
              title="報名完成"
              size="lg"
              ok-only
              ok-title="關閉"
              @ok="GoToPathHome"
            >
              <p>感謝您報名國家底圖空間資訊應用成果發表週。</p>
              <p>確認信函以寄至：{{ SignData.email }}</p>
              <p>如未收到【確認信】，請至【垃圾郵件匣】查看。</p>
            </b-modal>
            <b-modal
              id="modal-timeOut"
              v-model="modal_timeOut_show"
              title="報名日期已截止"
              size="lg"
              ok-only
              ok-title="關閉"
            >
              <p>報名日期:</p>
              <p>2021/9/11 上午 11:00:00 ~ 2021/10/5 下午 12:00</p>
            </b-modal>
          </div>
        </div>
      </b-overlay>

      <!-- <div id="fifthPage" class="section forum-results">
          <div class="container">
            <h2>成果專區</h2>
          </div>
        </div> -->

      <div id="sixthPage" class="section forum-traffic">
        <div class="container">
          <h2>交通指南</h2>
          <div class="row mrt align-items-center">
            <div class="text-center col-auto">
              <img src="imgs/mrt.png" class="img-fluid" alt="" /><br />
              <strong>捷運</strong>
            </div>
            <div class="col align-self-stretch">
              <div class="mrtSelf">
                <ul class="mb-0 list-unstyled">
                  <li>
                    <span>捷運新店線【公館站】2號出口：</span>2號出口左轉
                    (步行2分鐘)
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row bus align-items-center">
            <div class="text-center col-auto">
              <img src="imgs/bus.png" class="img-fluid" alt="" /><br />
              <strong>公車</strong>
            </div>

            <div class="col">
              <ul class="mb-0 list-unstyled">
                <li><span>捷運公館站一 (羅斯福路)：</span>254</li>
                <li>
                  <span>捷運公館站(公車專用道-往西區方向)：</span
                  >0南、1、109、208、208(高架線)、208(區間車)、208(基河二期國宅線)、236、251、252、253、278、284、284(直行)、290、52、642、643、644、648、660、671、672、673、676、74、907、景美女中-榮總快速公車、棕12、綠11、綠13、藍28
                </li>
                <li>
                  <span>捷運公館站(公車專用道-往新店方向)：</span
                  >207、278、280、280(直達車)、284、311、505、530、606、606區間車、668、
                  675、676、松江幹線、松江-新生幹線、敦化幹線、藍28
                </li>
                <li><span>公館 (羅斯福路基隆路口)：</span>671</li>
                <li>
                  <span>公館 (基隆路)：</span
                  >1、207、254、275、275(副)、650、672、673、907、南港軟體園區通勤專車(雙和線)
                </li>
                <li><span>仁愛路二段：</span>214、248、606</li>
                <li>
                  <span>信義杭州路口 (往101)：</span
                  >0東、20、22、204、670、671、信義幹線、信義新幹線、1503
                </li>
              </ul>
            </div>
          </div>

          <div class="row car align-items-center">
            <div class="text-center col-auto">
              <img src="imgs/car.png" class="img-fluid" alt="" /><br />
              <strong>開車</strong>
            </div>

            <div class="col">
              <ul class="mb-0 list-unstyled">
                <li>
                  <span
                    >公館水源市場對面羅斯福路上，近羅斯福路與基隆路交叉口</span
                  >
                </li>
                <li>
                  <span>國道一號：</span
                  >由松江路交流道下，轉建國高架道路南行至和平東路出口，續行辛亥路至基隆路右轉，直行至羅
                  斯福路再右轉，隨即於右側即可見集思台大會議中心。
                </li>
                <li>
                  <span>國道三號：</span
                  >由台北聯絡道下辛亥路端，接基隆路右轉羅斯福路，隨即於右側即可見集思台大會議中心。
                </li>
              </ul>
            </div>
          </div>
        </div>
        <iframe
          src="https://ezsign.gis.tw/moi1004event/map/Map.html"
          width="100%"
          height="450"
          frameborder="0"
          style="border: 0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetOpen2,
  apiCheckRegister,
  apiGetAT_ID,
  apiNewRegister,
  apiGetKey,
  apiGetToken,
  apiGetMailToken,
  apiSendMail,
  apiSetLogRequest,
  apiGetSession1Count,
  apiGetSession2Count,
  apiGetSession3Count,
  apiGetSession4Count,
  apiGetSession5Count,
  apiGetSession6Count,
} from "../api/API";
export default {
  data() {
    return {
      State: true,
      lunchVisible: false,
      RG_ID: null,
      learn: "0",
      session1Disable: false,
      session2Disable: false,
      session3Disable: false,
      session4Disable: false,
      session5Disable: false,
      session6Disable: false,
      session1: false,
      session2: false,
      session3: false,
      session4: false,
      session5: false,
      session6: false,
      join1: "1",
      join2: "1",
      join3: "1",
      join4: "1",
      join5: "1",
      join6: "1",
      terms1: false,
      terms2: false,
      terms3: false,
      govORsch: "0",
      SignData: {
        name: "",
        position: "",
        phone: "",
        idNum: "",
        sex: "0",
        email: "",
        Lunch: "2",
        Join: "0",
        Covid1: "0",
        Covid1_Another: "",
        Covid2: "0",
        Covid2_Another: "",
        Covid3: "0",
        Covid3_Another: "",
      },
      modal_terms_show: false,
      modal_2_show: false,
      modal_timeOut_show: false,
      overlay: false,
      overlay_type: "border",
    };
  },
  mounted() {
    this.CheckIsOpen();
    this.GetSession1Count();
    this.GetSession2Count();
    this.GetSession3Count();
    this.GetSession4Count();
    this.GetSession5Count();
    this.GetSession6Count();
  },
  methods: {
    //取得各場次人數
    //10/4(一) NGIS整合建置應用成果/柏拉圖廳
    async GetSession1Count() {
      try {
        const toekn = (await apiGetMailToken()).data;
        var data = {
          Token: toekn,
        };
        const Session1Count = JSON.parse(
          (await apiGetSession1Count(data)).data
        );
        console.log(Session1Count);
        var peopleCount = Session1Count.Data;
        //柏拉圖廳 75人
        if (peopleCount >= 85) {
          // alert("人數超過");
          this.session1Disable = true;
        }
        // else {
        //   alert("sessionP1:" + this.sessionP1);
        // }
      } catch (err) {
        console.log(err);
      }
    },
    //10/5(二) 3D國家底圖建置現況及應用/柏拉圖廳
    async GetSession2Count() {
      try {
        const toekn = (await apiGetMailToken()).data;
        var data = {
          Token: toekn,
        };
        const Session2Count = JSON.parse(
          (await apiGetSession2Count(data)).data
        );
        console.log(Session2Count);
        var peopleCount = Session2Count.Data;
        //柏拉圖廳 75人
        if (peopleCount >= 85) {
          this.session2Disable = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    //10/6(三) DTM加值應用成果/2021GIS競賽3D新創應用組初選活動暨人氣獎頒獎/米開朗基羅廳
    async GetSession3Count() {
      try {
        const toekn = (await apiGetMailToken()).data;
        var data = {
          Token: toekn,
        };
        const Session3Count = JSON.parse(
          (await apiGetSession3Count(data)).data
        );
        console.log(Session3Count);
        var peopleCount = Session3Count.Data;
        //米開朗基羅廳 43人
        if (peopleCount >= 53) {
          this.session3Disable = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    //10/6(三) 三維空間資訊基礎環境共構及資料聯盟應用成果/米開朗基羅廳
    async GetSession4Count() {
      try {
        const toekn = (await apiGetMailToken()).data;
        var data = {
          Token: toekn,
        };
        const Session4Count = JSON.parse(
          (await apiGetSession4Count(data)).data
        );
        console.log(Session4Count);
        var peopleCount = Session4Count.Data;
        //米開朗基羅廳 43人
        if (peopleCount >= 41) {
          this.session4Disable = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    //10/7(四) 高精地圖標準及智能移動測繪技術/洛克廳
    async GetSession5Count() {
      try {
        const toekn = (await apiGetMailToken()).data;
        var data = {
          Token: toekn,
        };
        const Session5Count = JSON.parse(
          (await apiGetSession5Count(data)).data
        );
        console.log(Session5Count);
        var peopleCount = Session5Count.Data;
        //米開朗基羅廳 45人
        if (peopleCount >= 5) {
          this.session5Disable = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    //10/8(五) Earth Observation for Geo-Information System - International Partnership/達文西廳
    async GetSession6Count() {
      try {
        const toekn = (await apiGetMailToken()).data;
        var data = {
          Token: toekn,
        };
        const Session6Count = JSON.parse(
          (await apiGetSession6Count(data)).data
        );
        console.log(Session6Count);
        var peopleCount = Session6Count.Data;
        //達文西廳 24人
        if (peopleCount >= 34) {
          this.session6Disable = true;
        }
      } catch (err) {
        console.log(err);
      }
    },

    checkLunch() {
      if (this.session1 == false) {
        this.join1 = "1";
      }
      if (this.session2 == false) {
        this.join2 = "1";
      }
      if (this.session3 == false) {
        this.join3 = "1";
      }
      if (this.session4 == false) {
        this.join4 = "1";
      }
      if (this.session5 == false) {
        this.join5 = "1";
      }
      if (this.session6 == false) {
        this.join6 = "1";
      }

      if (
        this.join1 == "0" ||
        this.join2 == "0" ||
        this.join3 == "0" ||
        this.join4 == "0" ||
        this.join5 == "0" ||
        this.join6 == "0"
      ) {
        this.lunchVisible = true;
      } else {
        this.lunchVisible = false;
      }
    },
    async SendMail(id, count) {
      try {
        const token = (await apiGetMailToken()).data;
        //console.log(token);

        var sessionvalue1 = "";
        var join1value = "";
        if (this.session1) {
          sessionvalue1 = "1";
          join1value = this.join1;
        }
        var sessionvalue2 = "";
        var join2value = "";
        if (this.session2) {
          sessionvalue2 = "1";
          join2value = this.join2;
        }
        var sessionvalue3 = "";
        var join3value = "";
        if (this.session3) {
          sessionvalue3 = "1";
          join3value = this.join3;
        }
        var sessionvalue4 = "";
        var join4value = "";
        if (this.session4) {
          sessionvalue4 = "1";
          join4value = this.join4;
        }
        var sessionvalue5 = "";
        var join5value = "";
        if (this.session5) {
          sessionvalue5 = "1";
          join5value = this.join5;
        }
        var sessionvalue6 = "";
        var join6value = "";
        if (this.session6) {
          sessionvalue6 = "1";
          join6value = this.join6;
        }

        var info = {
          id: id,
          mail: this.SignData.email,
          name: this.SignData.name,
          session1: sessionvalue1,
          session2: sessionvalue2,
          session3: sessionvalue3,
          session4: sessionvalue4,
          session5: sessionvalue5,
          session6: sessionvalue6,
          join1: join1value,
          join2: join2value,
          join3: join3value,
          join4: join4value,
          join5: join5value,
          join6: join6value,
          RG_ID: this.RG_ID,
          TokenID: "",
          Token: token,
          Page: "",
        };
        const sendMail = JSON.parse((await apiSendMail(info)).data);
        //console.log(sendMail);
        if (sendMail.Status) {
          this.overlay = false;
          this.modal_2_show = true;
        } else {
          if (count <= 5) {
            count++;
            this.SendMail(id, count);
          } else {
            const token = (await apiGetMailToken()).data;
            var lo = {
              Id: this.SignData.email,
              Message: "寄件失敗",
              TokenID: "",
              Token: token,
              Page: "",
            };
            const SetLog = JSON.parse((await apiSetLogRequest(lo)).data);
            console.error(SetLog);
            this.overlay = false;
            alert("寄件失敗，請聯絡相關人員 ");
          }
        }
      } catch (err) {
        if (count <= 5) {
          count++;
          this.SendMail(id, count);
        } else {
          const token = (await apiGetMailToken()).data;
          var logs = {
            Id: this.SignData.email,
            Message: err,
            TokenID: "",
            Token: token,
            Page: "",
          };
          const SetLog = JSON.parse((await apiSetLogRequest(logs)).data);
          console.error(SetLog);
          this.overlay = false;
          alert("寄件出現錯誤，請聯絡相關人員 ");
        }
      }
    },
    async Register() {
      try {
        this.overlay = true;
        const key = (await apiGetKey()).data[0]["Key"];
        //console.log(key);
        const token = (await apiGetToken(key)).data[0]["Token"];
        //console.log(token);
        const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
        //console.log(AT_ID);
        var lunch = "";
        if (
          this.join1 == "1" &&
          this.join2 == "1" &&
          this.join3 == "1" &&
          this.join4 == "1" &&
          this.join5 == "1" &&
          this.join6 == "1"
        ) {
          lunch = "CV20210826174552616";
        } else {
          if (this.SignData.Lunch == "0") {
            lunch = "CV20210826174544217";
          } else if (this.SignData.Lunch == "1") {
            lunch = "CV20210826174548873";
          } else {
            lunch = "CV20210826174552616";
          }
        }

        //CL20180307140909094
        var RegisterData = [
          //姓名
          { RD_CLID: "CL20190311182727127", RD_Value: this.SignData.name },
          //稱謂
          { RD_CLID: "CL20180307140916893", RD_Value: this.SignData.position },
          //性別
          {
            RD_CLID: "CL20190311193313384",
            RD_Value:
              this.SignData.sex == "0"
                ? "CV20190311193344352"
                : "CV20190311193335665",
          },
          //手機號碼
          {
            RD_CLID: "CL20180314141037348",
            RD_Value: this.SignData.phone,
          },
          //身分證號
          { RD_CLID: "CL20180307140846991", RD_Value: this.SignData.idNum },
          //飲食需求(單選)
          {
            RD_CLID: "CL20210826174533475",
            RD_Value: lunch,
          },
          // //參加方式
          // {
          //   RD_CLID: "CL20210826174412786",
          //   RD_Value:
          //     this.SignData.Join == "0"
          //       ? "CV20210826174443609"
          //       : "CV20210826174447609",
          // },
          //10/4(一) NGIS整合建置應用成果/柏拉圖廳-是否參加
          {
            RD_CLID: "CL20210906174840834",
            RD_Value:
              this.session1 == true
                ? "CV20210906175323592"
                : "CV20210906175328888",
          },
          //10/5(二) 3D國家底圖建置現況及應用/柏拉圖廳-是否參加
          {
            RD_CLID: "CL20210906174917794",
            RD_Value:
              this.session2 == true
                ? "CV20210906175334373"
                : "CV20210906175339045",
          },
          //10/6(三) DTM加值應用成果/2021GIS競賽3D新創應用組初選活動暨人氣獎頒獎/米開朗基羅廳-是否參加
          {
            RD_CLID: "CL20210906175001893",
            RD_Value:
              this.session3 == true
                ? "CV20210906175346486"
                : "CV20210906175351038",
          },
          //10/6(三) 三維空間資訊基礎環境共構及資料聯盟應用成果/米開朗基羅廳-是否參加
          {
            RD_CLID: "CL20210906175017810",
            RD_Value:
              this.session4 == true
                ? "CV20210906175620937"
                : "CV20210906175624812",
          },
          //10/7(四) 高精地圖標準及智能移動測繪技術/洛克廳-是否參加
          {
            RD_CLID: "CL20210906175042371",
            RD_Value:
              this.session5 == true
                ? "CV20210906175401879"
                : "CV20210906175406711",
          },
          //10/8(五) Earth Observation for Geo-Information System -International Partnership/達文西廳-是否參加
          {
            RD_CLID: "CL20210906175059894",
            RD_Value:
              this.session6 == true
                ? "CV20210906175418080"
                : "CV20210906175421705",
          },

          //COVID-19是否出現症狀-其他
          {
            RD_CLID: "CL20210826173914468",
            RD_Value: this.SignData.Covid1_Another,
          },
          //COVID-19出國史-其他
          {
            RD_CLID: "CL20210826173929698",
            RD_Value: this.SignData.Covid2_Another,
          },
          //COVID-19病患接觸史-其他
          {
            RD_CLID: "CL20210826173944377",
            RD_Value: this.SignData.Covid3_Another,
          },
        ];
        //單位
        var gscVal = "";
        if (this.govORsch == "0") {
          gscVal = "CV20201022102804909";
        }
        if (this.govORsch == "1") {
          gscVal = "CV20201022102816730";
        }
        if (this.govORsch == "2") {
          gscVal = "CV20201016141128829";
        }
        RegisterData.push({ RD_CLID: "CL20201006102625094", RD_Value: gscVal });

        //COVID-19是否出現症狀
        var covid1_item = "";
        if (this.SignData.Covid1 == "0") {
          covid1_item = "CV20210826215421777";
        }
        if (this.SignData.Covid1 == "1") {
          covid1_item = "CV20210826215426463";
        }
        if (this.SignData.Covid1 == "2") {
          covid1_item = "CV20210826215430838";
        }
        if (this.SignData.Covid1 == "3") {
          covid1_item = "CV20210826215437511";
        }
        if (this.SignData.Covid1 == "4") {
          covid1_item = "CV20210826215443042";
        }
        if (this.SignData.Covid1 == "5") {
          covid1_item = "CV20210826215447980";
        }
        RegisterData.push({
          RD_CLID: "CL20210826215321959",
          RD_Value: covid1_item,
        });
        //COVID-19出國史
        var covid2_item = "";
        if (this.SignData.Covid2 == "0") {
          covid2_item = "CV20210826215540889";
        }
        if (this.SignData.Covid2 == "1") {
          covid2_item = "CV20210826215545500";
        }
        RegisterData.push({
          RD_CLID: "CL20210826215520054",
          RD_Value: covid2_item,
        });
        //COVID-19病患接觸史
        var covid3_item = "";
        if (this.SignData.Covid3 == "0") {
          covid3_item = "CV20210826215559261";
        }
        if (this.SignData.Covid3 == "1") {
          covid3_item = "CV20210826215554968";
        }
        RegisterData.push({
          RD_CLID: "CL20210826215530907",
          RD_Value: covid3_item,
        });

        //10/4(一) NGIS整合建置應用成果/柏拉圖廳-參加方式
        if (this.session1 == true) {
          RegisterData.push({
            RD_CLID: "CL20210906174904517",
            RD_Value:
              this.join1 == "0" ? "CV20210906175502583" : "CV20210906175506646",
          });
        }
        ////10/5(二) 3D國家底圖建置現況及應用/柏拉圖廳-參加方式
        if (this.session2 == true) {
          RegisterData.push({
            RD_CLID: "CL20210906175127748",
            RD_Value:
              this.join2 == "0" ? "CV20210906175515789" : "CV20210906175512617",
          });
        }
        //10/6(三) DTM加值應用成果/2021GIS競賽3D新創應用組初選活動暨人氣獎頒獎/米開朗基羅廳-參加方式
        if (this.session3 == true) {
          RegisterData.push({
            RD_CLID: "CL20210906174947085",
            RD_Value:
              this.join3 == "0" ? "CV20210906175522054" : "CV20210906175525851",
          });
        }
        //10/6(三) 三維空間資訊基礎環境共構及資料聯盟應用成果/米開朗基羅廳-參加方式
        if (this.session4 == true) {
          RegisterData.push({
            RD_CLID: "CL20210906175027857",
            RD_Value:
              this.join4 == "0" ? "CV20210906175608536" : "CV20210906175604645",
          });
        }
        //10/7(四) 高精地圖標準及智能移動測繪技術/洛克廳-參加方式
        if (this.session5 == true) {
          RegisterData.push({
            RD_CLID: "CL20210906175050434",
            RD_Value:
              this.join5 == "0" ? "CV20210906175537117" : "CV20210906175533586",
          });
        }
        //10/8(五) Earth Observation for Geo-Information System -International Partnership/達文西廳-參加方式
        if (this.session6 == true) {
          RegisterData.push({
            RD_CLID: "CL20210906175112084",
            RD_Value:
              this.join6 == "0" ? "CV20210906175543820" : "CV20210906175547737",
          });
        }

        var Register = {
          RG_ATID: AT_ID,
          RG_Email: this.SignData.email,
          RG_CName: this.SignData.name,
          RG_LName: "",
          RG_FName: "",
          VolumnData: RegisterData,
        };
        console.log(Register);

        const NewRegister = await apiNewRegister(token, Register);
        //console.log(NewRegister.data["Result"]);
        this.RG_ID = NewRegister.data["Result"];

        if (
          NewRegister.data["Result"] ==
          "該活動尚未開啟報名(This activity is not open yet.)"
        ) {
          this.modal_timeOut_show = true;
        } else {
          const isRegister = (await apiCheckRegister(this.SignData.email))
            .data[0]["IsRegister"];
          if (isRegister == "true") {
            this.SendMail(NewRegister.data["Result"], 1);
          } else {
            this.overlay = false;
            alert("報名失敗");
          }
        }
      } catch (err) {
        console.error(err);
        alert("註冊出現錯誤，請聯絡相關人員");
      }
    },
    async CheckRegister() {
      try {
        const isRegister = (await apiCheckRegister(this.SignData.email))
          .data[0]["IsRegister"];
        if (isRegister == "false") {
          this.Register();
        } else {
          alert("此Emial已有報名過");
        }
      } catch (err) {
        console.error(err);
        alert("檢查出現錯誤，請聯絡相關人員");
      }
    },
    CheckState(val, CMail) {
      if ((val == "" || !CMail) && !this.State) return false;
      else return null;
    },
    CheckData() {
      if (
        this.SignData.name == "" ||
        this.SignData.email == "" ||
        this.SignData.position == ""
      ) {
        this.State = false;
        window.location.hash = "#sign";
      } else if (
        this.session1 == false &&
        this.session2 == false &&
        this.session3 == false &&
        this.session4 == false &&
        this.session5 == false &&
        this.session6 == false
      ) {
        alert("請至少參加一場次");
      } else if (
        this.SignData.Covid1 == 5 ||
        this.SignData.Covid2 == 1 ||
        this.SignData.Covid3 == 1
      ) {
        var err = 1;
        if (this.SignData.Covid1 == 5) {
          if (this.SignData.Covid1_Another == "") {
            alert("請輸入原因");
          } else {
            err = null;
          }
        }
        if (this.SignData.Covid2 == 1) {
          if (this.SignData.Covid2_Another == "") {
            alert("請輸入原因");
          } else {
            err = null;
          }
        }
        if (this.SignData.Covid3 == 1) {
          if (this.SignData.Covid3_Another == "") {
            alert("請輸入原因");
          } else {
            err = null;
          }
        }
        if (err == null) {
          this.CheckRegister();
        }
      } else {
        this.CheckRegister();
        // alert("註冊");
      }
    },
    CheckTerms() {
      if (
        this.terms1 == false ||
        this.terms2 == false ||
        this.terms3 == false
      ) {
        this.modal_terms_show = true;
      } else {
        this.CheckData();
      }
    },
    async CheckIsOpen() {
      const key = (await apiGetKey()).data[0]["Key"];
      const token = (await apiGetToken(key)).data[0]["Token"];
      const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
      const isOpen = (await apiGetOpen2(token, AT_ID)).data[0]["IsOpen"];
      if (isOpen != "true") {
        this.modal_timeOut_show = true;
        this.overlay_type = "";
        this.overlay = true;
      }
    },
  },
  computed: {
    CheckMail() {
      const mailRegExp = new RegExp(
        "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
      );
      return mailRegExp.test(this.SignData.email);
    },
    CheckidNum() {
      const idRegExp = new RegExp(
        "^[A-Za-z]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+$"
      );
      return idRegExp.test(this.SignData.idNum);
    },
    CheckPhone() {
      var MobileReg = /^(09)[0-9]{8}$/;
      return this.SignData.phone.match(MobileReg) ? true : false;
    },
  },
};
</script>